(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["before-after"] && !Shopify.designMode) return;
  try {
    class BeforeAfterSlider {
    constructor(element) {
      this.container = element;
      this.slider = this.container.querySelector('[data-before-after-slider]');
      this.beforeImage = this.container.querySelector('.before-after-before');
      this.isDragging = false;
      this.startX = 0;
      this.startLeft = 0;

      this.init();
    }

    init() {
      this.slider.addEventListener('mousedown', this.startDragging.bind(this));
      document.addEventListener('mousemove', this.drag.bind(this));
      document.addEventListener('mouseup', this.stopDragging.bind(this));
      
      // Touch events for mobile
      this.slider.addEventListener('touchstart', this.startDragging.bind(this));
      document.addEventListener('touchmove', this.drag.bind(this));
      document.addEventListener('touchend', this.stopDragging.bind(this));

      // Set initial position to center
      this.updateSliderPosition(50);
    }

    startDragging(e) {
      this.isDragging = true;
      this.startX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
      
      // Get current position from clip-path
      const clipPath = this.beforeImage.style.clipPath;
      if (clipPath) {
        const match = clipPath.match(/inset\(0 (\d+(?:\.\d+)?)% 0 0\)/);
        this.startLeft = match ? 100 - parseFloat(match[1]) : 50;
      } else {
        this.startLeft = 50;
      }
      
      e.preventDefault();
    }

    drag(e) {
      if (!this.isDragging) return;

      const currentX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
      const deltaX = currentX - this.startX;
      const containerWidth = this.container.offsetWidth;
      const percentage = Math.max(0, Math.min(100, this.startLeft + (deltaX / containerWidth) * 100));

      this.updateSliderPosition(percentage);
      e.preventDefault();
    }

    stopDragging() {
      this.isDragging = false;
    }

    updateSliderPosition(percentage) {
      this.beforeImage.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
      this.slider.style.left = percentage + '%';
    }
  }

  // Initialize all before-after sliders
  document.addEventListener('DOMContentLoaded', function() {
    const beforeAfterContainers = document.querySelectorAll('.before-after-container');
    beforeAfterContainers.forEach(container => {
      new BeforeAfterSlider(container);
    });
  });

  // Handle dynamic content loading
  document.addEventListener('shopify:section:load', function(event) {
    const beforeAfterContainers = event.target.querySelectorAll('.before-after-container');
    beforeAfterContainers.forEach(container => {
      new BeforeAfterSlider(container);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
